import React from 'react';
import NewProjectWizardCard from './NewProjectWizardCard';
import styles from './css/index.module.css';
import checkIcon from './assets/check.svg';

export default function SetupTeamComplete({ inviteCount = 0, groupCount = 0, sentInvites = [], ndaRequired = false, onEnter }) {
    const inviteLabel = `${inviteCount} invitation${inviteCount === 1 ? '' : 's'} sent`;
    const groupLabel = `${groupCount} access group${groupCount === 1 ? '' : 's'} configured`;
    const ndaLabel = `NDA acceptance required for ${inviteCount} invitee${inviteCount === 1 ? '' : 's'}`;

    return (
        <NewProjectWizardCard title="Team setup complete" hideProgress hideFooter showHeaderDivider>
            <div className={styles.tmCompleteBody}>
                <ul className={styles.readyList}>
                    <li className={styles.readyItem}>
                        <span className={`${styles.preparingIcon} ${styles.preparingIconDone}`} aria-hidden="true">
                            <img src={checkIcon} alt="" width={10} height={8} className={styles.preparingCheck} />
                        </span>
                        <span className={styles.readyLabel}>{inviteLabel}</span>
                    </li>
                    <li className={styles.readyItem}>
                        <span className={`${styles.preparingIcon} ${styles.preparingIconDone}`} aria-hidden="true">
                            <img src={checkIcon} alt="" width={10} height={8} className={styles.preparingCheck} />
                        </span>
                        <span className={styles.readyLabel}>{groupLabel}</span>
                    </li>
                    {ndaRequired && inviteCount > 0 ? (
                        <li className={styles.readyItem}>
                            <span className={`${styles.preparingIcon} ${styles.preparingIconDone}`} aria-hidden="true">
                                <img src={checkIcon} alt="" width={10} height={8} className={styles.preparingCheck} />
                            </span>
                            <span className={styles.readyLabel}>{ndaLabel}</span>
                        </li>
                    ) : null}
                </ul>
                {sentInvites.length ? (
                    <div className={styles.tmInviteList}>
                        {sentInvites.map(item => (
                            <div key={`${item.email}-${item.groupName}`} className={styles.tmInviteRow}>
                                <p className={styles.tmInviteEmail}>{item.email}</p>
                                <p className={styles.tmInviteGroup}>{item.groupName}</p>
                            </div>
                        ))}
                    </div>
                ) : null}
                <div className={styles.tmCompleteActions}>
                    <button type="button" className={`${styles.primaryButton} ${styles.readyEnter}`} onClick={onEnter}>
                        Enter project
                    </button>
                </div>
            </div>
        </NewProjectWizardCard>
    );
}
